<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/frameworks']" appearance="plain" variant="neutral">&larr; Back to UI Frameworks</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>Bootstrap</h1>
					<p waBody="m" waText>Bootstrap 5.3.8 &mdash; the most popular responsive CSS framework with 40+ type-safe Java component wrappers. Cards, modals, navbars, forms, carousels, accordions, toasts, alerts, dropdowns, and more with CRTP fluent APIs, SCSS theming, Popper.js positioning, and ng-bootstrap 20 Angular integration.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">Bootstrap 5.3.8</wa-tag>
						<wa-tag pill variant="neutral">ng-bootstrap 20</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:bootstrap</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.bootstrap</p>
					<p waBody="s" waText>Built on: Bootstrap 5.3.8</p>
				</div>
				<wa-details open summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_39" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_40" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details open summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_41" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Features (15)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>40+ components &mdash; Cards, modals, navbars, accordions, carousels, toasts, alerts, badges, buttons, and more</p>
						<p waBody="s" waColorText="quiet" waText>SCSS theming &mdash; Bootstrap SCSS loaded for full theme customization</p>
						<p waBody="s" waColorText="quiet" waText>ng-bootstrap 20 &mdash; Angular-native Bootstrap components</p>
						<p waBody="s" waColorText="quiet" waText>Responsive grid &mdash; Container, row, and column layout system</p>
						<p waBody="s" waColorText="quiet" waText>Form controls &mdash; Input groups, form groups, validation styles, date/time pickers</p>
						<p waBody="s" waColorText="quiet" waText>Navigation &mdash; Navbar, navs, tabs, breadcrumbs, pagination</p>
						<p waBody="s" waColorText="quiet" waText>Modals &mdash; Show/hide/shown/hidden event lifecycle</p>
						<p waBody="s" waColorText="quiet" waText>Carousel &mdash; Slide shows with events, features, and options</p>
						<p waBody="s" waColorText="quiet" waText>Dropdown &mdash; Toggleable menus with events and positioning via Popper.js</p>
						<p waBody="s" waColorText="quiet" waText>Button groups &mdash; Checkbox, radio, switch, and toolbar variants</p>
						<p waBody="s" waColorText="quiet" waText>Cards &mdash; Flexible content containers with themed layouts</p>
						<p waBody="s" waColorText="quiet" waText>Toasts &mdash; Lightweight notification components with events</p>
						<p waBody="s" waColorText="quiet" waText>Auto component detection &mdash; IOnComponentAdded SPI auto-applies Bootstrap classes</p>
						<p waBody="s" waColorText="quiet" waText>CRTP fluent API for component configuration</p>
						<p waBody="s" waColorText="quiet" waText>Zero configuration &mdash; auto-registered via ServiceLoader SPI</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_42" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
							<wa-tag pill variant="success">provides IGuiceScanModuleInclusions</wa-tag>
							<wa-tag pill variant="success">provides IOnComponentAdded</wa-tag>
							<wa-tag pill variant="success">provides IOnComponentConfigured</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://getbootstrap.com/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://getbootstrap.com/docs/</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/JWebMP</wa-tag>
				</div>
			</div>
		</wa-card>
		<div class="wa-stack wa-gap-m">
			<h2 waHeading="l" waText>Components &#40;35&#41;</h2>
			<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
			<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSAccordion</h4>
						<p waBody="s" waColorText="quiet" waText>Collapsible content panels with show/hide transitions. Uses ng-bootstrap NgbAccordion directive.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
							<wa-tag pill variant="neutral">4 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsaccordion']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSAlert</h4>
						<p waBody="s" waColorText="quiet" waText>Single dismissible alert message with contextual styling. Pre-styled variants include BSAlertPrimary, BSAlertSuccess, BSAlertDanger, BSAlertWarning, BSAlertInfo, BSAlertDark, BSAlertLight, and BSAlertSecondary.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsalert']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSBadge</h4>
						<p waBody="s" waColorText="quiet" waText>Inline badge labels with contextual colour variants. Pre-styled variants include BSBadgePrimary, BSBadgeSuccess, BSBadgeDanger, BSBadgeWarning, BSBadgeInfo, BSBadgeDark, BSBadgeLight, and BSBadgeSecondary.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsbadge']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSBreadcrumbContainer</h4>
						<p waBody="s" waColorText="quiet" waText>Breadcrumb navigation trail. Contains BSBreadCrumbItem entries with optional links.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsbreadcrumb-container']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSButton</h4>
						<p waBody="s" waColorText="quiet" waText>Enhanced buttons with size, colour, outline, and pressed states. Pre-styled variants include BSButtonPrimary, BSButtonDanger, BSButtonSuccess, BSButtonWarning, etc., plus outline versions.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">17 methods</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsbutton']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSButtonGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Button groups, toolbars, checkbox and radio button sets.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsbutton-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSCheckBox</h4>
						<p waBody="s" waColorText="quiet" waText>Styled checkbox inputs with contextual colour variants. Pre-styled variants include BSCheckBoxPrimary, BSCheckBoxDanger, BSCheckBoxSuccess, etc.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bscheck-box']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSRadioButton</h4>
						<p waBody="s" waColorText="quiet" waText>Styled radio button inputs with colour variants. Pre-styled variants include BSRadioButtonPrimary, BSRadioButtonDanger, BSRadioButtonSuccess, etc.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsradio-button']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSSwitch</h4>
						<p waBody="s" waColorText="quiet" waText>Toggle switch styled as a Bootstrap custom switch. Extends BSFormGroup with a checkbox input rendered as a switch.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsswitch']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSCard</h4>
						<p waBody="s" waColorText="quiet" waText>Flexible content container with header, body, footer, images, list groups, and themed variants. Replaces the old panels, wells, and thumbnails.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">15 methods</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bscard']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSCarousel</h4>
						<p waBody="s" waColorText="quiet" waText>Slideshow component for cycling through images or slides of text. Uses ng-bootstrap NgbCarousel with navigation, indicators, and pause controls.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">6 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bscarousel']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSCloseIcon</h4>
						<p waBody="s" waColorText="quiet" waText>Close/dismiss button typically used inside modals, alerts, and toasts. Renders a small &times; icon button.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsclose-icon']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSCollapse</h4>
						<p waBody="s" waColorText="quiet" waText>Toggle visibility of elements with animation. Provides a static link&#40;&#41; method to wire a toggler to collapsible content.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">1 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bscollapse']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSContainer</h4>
						<p waBody="s" waColorText="quiet" waText>Responsive layout containers. Use BSContainerOptions for fixed-width or fluid-width variants. Also provides BSRow and BSColumn for grid layouts.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bscontainer']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSDatePicker</h4>
						<p waBody="s" waColorText="quiet" waText>Date selection widget backed by ng-bootstrap NgbDatepicker. Renders a calendar popup for date input.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsdate-picker']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSDropDown</h4>
						<p waBody="s" waColorText="quiet" waText>Toggleable dropdown menus with Popper.js positioning. Uses ng-bootstrap NgbDropdown directive.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">3 props</wa-tag>
							<wa-tag pill variant="neutral">9 methods</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsdrop-down']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSFigure</h4>
						<p waBody="s" waColorText="quiet" waText>HTML5 figure element with optional caption for displaying images and media with descriptive text.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsfigure']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSFileUpload</h4>
						<p waBody="s" waColorText="quiet" waText>Custom file input control with Bootstrap styling. Displays selected filename in a label.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsfile-upload']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSForm</h4>
						<p waBody="s" waColorText="quiet" waText>Form component with groups, input sets, controls, validation, and Angular reactive form binding. Provides factory methods for all standard input types.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">1 props</wa-tag>
							<wa-tag pill variant="neutral">24 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsform']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSImage</h4>
						<p waBody="s" waColorText="quiet" waText>Responsive image component with Bootstrap utility classes for fluid sizing and thumbnail styling.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsimage']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSJumbotron</h4>
						<p waBody="s" waColorText="quiet" waText>Hero section for showcasing key content with large padding and rounded corners. Ideal for marketing pages and call-to-action banners.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsjumbotron']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSListGroup</h4>
						<p waBody="s" waColorText="quiet" waText>Flexible list group with active, disabled, and contextual items. Supports list items, link items, and button items.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bslist-group']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSMedia</h4>
						<p waBody="s" waColorText="quiet" waText>Media object for aligning images or icons alongside textual content. Common for comment threads, tweets, and list items.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsmedia']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSModal</h4>
						<p waBody="s" waColorText="quiet" waText>Modal dialog with show/hide events, header/body/footer parts, and ng-bootstrap NgbModal integration. Supports backdrop, centering, keyboard dismiss, sizing, and fullscreen mode.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">7 props</wa-tag>
							<wa-tag pill variant="neutral">11 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsmodal']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSNavBar</h4>
						<p waBody="s" waColorText="quiet" waText>Responsive navigation bar with brand, toggler, collapse, colour schemes, and positioning. Wraps content in a BSContainer with a collapsible section.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">2 props</wa-tag>
							<wa-tag pill variant="neutral">15 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsnav-bar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSNavs</h4>
						<p waBody="s" waColorText="quiet" waText>Navigation component supporting tabs, pills, vertical orientation, fill, and justified layouts. Uses ng-bootstrap NgbNav directive.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">5 props</wa-tag>
							<wa-tag pill variant="neutral">10 methods</wa-tag>
							<wa-tag pill variant="success">2 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsnavs']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSPagination</h4>
						<p waBody="s" waColorText="quiet" waText>Pagination navigation with page links, sizing, and alignment options for multi-page content.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">3 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bspagination']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSPopOver</h4>
						<p waBody="s" waColorText="quiet" waText>Configurable popovers with title, content, placement, triggers, animation, and auto-close behaviour. Uses ng-bootstrap NgbPopover directive.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">8 props</wa-tag>
							<wa-tag pill variant="neutral">11 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bspop-over']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSProgressBar</h4>
						<p waBody="s" waColorText="quiet" waText>Progress bar with support for percentage values, striping, animation, stacking, colour types, value display, and custom height. Uses ng-bootstrap NgbProgressbar.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="brand">7 props</wa-tag>
							<wa-tag pill variant="neutral">8 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsprogress-bar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSRange</h4>
						<p waBody="s" waColorText="quiet" waText>Range slider input with Bootstrap styling for selecting numeric values within a range.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsrange']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSSelect</h4>
						<p waBody="s" waColorText="quiet" waText>Styled select dropdown with Bootstrap form-select classes and size variants.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bsselect']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSTable</h4>
						<p waBody="s" waColorText="quiet" waText>Styled tables with striped, bordered, hover, small, and responsive options. Supports themed row variants like BSTableRowPrimary, BSTableRowDanger, BSTableRowSuccess, etc.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">9 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bstable']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSTimePicker</h4>
						<p waBody="s" waColorText="quiet" waText>Time selection widget backed by ng-bootstrap NgbTimepicker with hour, minute, and second spinners.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bstime-picker']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSToast</h4>
						<p waBody="s" waColorText="quiet" waText>Lightweight push notification with header, body, auto-hide, and configurable delay. Supports stacking via BSToastContainer.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">6 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bstoast']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
				<wa-card appearance="outlined">
					<div class="wa-stack wa-gap-xs">
						<h4 waHeading="s" waText>BSToggle</h4>
						<p waBody="s" waColorText="quiet" waText>Dropdown toggle component that wires a title &#40;button or link&#41; to a dropdown contents list. Used internally by BSDropDown.</p>
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="neutral">5 methods</wa-tag>
							<wa-tag pill variant="success">1 examples</wa-tag>
						</div>
						<wa-button [routerLink]="['/frameworks/bootstrap/bstoggle']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
					</div>
				</wa-card>
			</div>
		</div>
	</div>
</div>